import ViewController from "./class.ViewController";

/**
 * Responsible for bubbles.
 */
export default class TransporterViewBubble extends ViewController {
	/**
	 *
	 * @param {*} options
	 * @param {String} options.attributes.className
	 * @param {String} options.attributes.type "teacher", "student", "center"/"whiteboard"
	 * @param {boolean} options.attributes.virtual defaults to false
	 */
	constructor(options) {
		super(options);

		if (this.type === "center") {
			this.$el.addClass("whiteboard");
		} else if (this.type) {
			this.$el.addClass(this.type);
		}

		if (_.isUndefined(this.virtual)) {
			this.virtual = false;
		}
		if (this.virtual) {
			this.$el.addClass("virtual");
		}

		if (this.$el.hasClass("whiteboard")) {
			this.$el.css({display: "flex"});
		}

		this.$content = $(`<div class="content"></div>`).appendTo(this.$el);
	}

	/**
	 * Sets the contents of the bubble with $div.
	 *
	 * @param {*} $div
	 */
	setContent($div) {
		$div = this._replaceVariablesContent($div);
		this.$content.html("").append($div);

		return this;
	}

	/**
	 * Sets the contents of the bubble text.
	 *
	 * @param {string} text
	 */
	setText(text) {
		text = this._replaceVariablesContent(text);
		this.$content.text(text);

		return this;
	}

	/**
	 * Appends the contents of the bubble with $div.
	 *
	 * @param {*} $div
	 */
	appendContent($div) {
		$div = this._replaceVariablesContent($div);
		this.$content.append($div);

		return this;
	}

	/**
	 * Search a dom variable, replacing text with variables
	 * @param {*} $div
	 * @returns
	 */
	_replaceVariablesContent($div) {
		// Alter strings directly
		if (typeof $div == "string") {
			$div = this._replaceVariablesText($div);
		} else {
			const parent = this;
			// Check each part of the element and replace variables in the text parts
			$div.contents().each(function () {
				// nodeType 3 is a text node
				if (this.nodeType === 3) {
					this.nodeValue = parent._replaceVariablesText(this.nodeValue);
				} else {
					parent._replaceVariablesContent($(this));
				}
			});
		}
		return $div;
	}

	/**
	 * Look for variables in a string and replace them with the value
	 * @param {string} text
	 * @returns {string}
	 */
	_replaceVariablesText(text) {
		return this.mainController.transporterVariables.replaceVariablesText(text);
	}

	appendVirtualBubble() {
		var virtualBubble = this.layoutView.placeBubble(
			this.$content,
			"append",
			this.type,
			true
		);

		return virtualBubble;
	}

	/**
	 * Adds a floating decoration to the left of the bubble.
	 * Used for check/x.
	 *
	 * @param {string} text
	 */
	decorate(text) {
		let $decorator = this.$el.children(".decorator");
		if (!$decorator.length) {
			$decorator = $(`<div class="decorator aops-font"></div>`).prependTo(
				this.$el
			);
		}
		$decorator.text(text);
		this.$el.addClass("decorated");
	}

	/**
	 * Adds a check to the left of the bubble.
	 */
	pass() {
		this.decorate("q");
		this.$el.find(".decorator").css({
			color: "#4fa800",
		});
	}

	/**
	 * Adds an x to the left of the bubble.
	 */
	fail() {
		this.decorate("J");
		this.$el.find(".decorator").css({
			color: "#dd312f",
			visibility: "hidden",
		});
	}

	/**
	 * Sets the text align property of the bubble's content.
	 * @param {string} align
	 */
	setTextAlign(align) {
		if (_.isString(align)) {
			this.$content.css({"text-align": align});
		}

		return this;
	}

	async sticky() {
		if (this.type === "center" || this.type === "whiteboard") {
			if (this.mainView.sticky) {
				await this.mainView.collapseThenUnsticky();
			}
			this.mainView._sticky(this);
		}
	}
}
